import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import accountIconImg from "@static/img/dashboard/account.svg";

export const AccountIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={accountIconImg} viewBox="0 0 30 30" />;
};
